import {
    Button,
    Col,
    DatePicker,
    Form,
    Input,
    Row,
    Typography
} from "antd";
import moment from "moment";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
    loadAllAttendance,
} from "../../redux/rtk/features/attendance/attendanceSlice";
import { addLinkUser, loadAllIndivisualUser } from "../../redux/rtk/features/linkUser/linkUserSlice";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import LinkCompanyTblData from "./linkCompanyTblData";
import getCompanyIdFromToken from "../../utils/getCompanyIdFromToken";

const LinkCompany = ({ drawer }) => {
    const [loader, setLoader] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const users = useSelector((state) => state.linkUser?.linkUser || []);
    const dispatch = useDispatch();
    const { Title } = Typography;
    const [form] = Form.useForm();
    const companyId = getCompanyIdFromToken()

    useEffect(() => {
        dispatch(loadAllIndivisualUser());
    }, [dispatch]);

    const onFinish = async (values) => {
        if (values.joinDate) {
            values.joinDate = moment(values.joinDate).format("YYYY-MM-DD");
        }
        setLoader(true);
        const resp = await dispatch(addLinkUser({ 
            id: selectedUser?.id, // Save user id as userId
            joinDate: values.joinDate,
            company_id: companyId,
        }));
        if (resp.payload?.message === "success") {
            setLoader(false);
            form.resetFields();
            setSelectedUser(null);
            dispatch(loadAllAttendance());
        } else {
            setLoader(false);
        }
    };

    const onFinishFailed = () => {
        toast.warning("Failed at updating user information");
        setLoader(false);
    };

    const handleUserNameChange = (e) => {
        const UserName = e.target.value;
        const user = users.find(u => u.UserName === UserName);
        // console.log("uu", users);
        
        setSelectedUser(user || null);
        if (user) {
            form.setFieldsValue({ fullName: `${user.firstName} ${user.lastName}` });
        } else {
            form.setFieldsValue({ fullName: null });
        }
    };

    return (
        <Fragment>
            <UserPrivateComponent permission={"create-attendance"}>
                <Row className='mr-top' justify={drawer ? "center" : "space-between"}>
                    <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={drawer ? 22 : 12}
                        xl={drawer ? 22 : 12}
                        className='column-design border rounded card-custom'>
                        <Title level={4} className='m-2 mt-5 mb-5 text-center'>
                            User Information
                        </Title>

                        <Form
                            form={form}
                            style={{ marginBottom: "40px" }}
                            name='basic'
                            labelCol={{ span: 6 }}
                            wrapperCol={{ span: 12 }}
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                            autoComplete='off'>
                            <Form.Item
                                style={{ marginBottom: "10px" }}
                                label='User Name'
                                name='UserName'
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter a user name!",
                                    },
                                    {
                                        validator: (_, value) =>
                                            users.some(u => u.UserName === value)
                                                ? Promise.resolve()
                                                : Promise.reject(new Error("Invalid user name!")),
                                    },
                                ]}>
                                <Input
                                    placeholder='Enter User Name'
                                    onChange={handleUserNameChange}
                                />
                            </Form.Item>

                            <Form.Item
                                style={{ marginBottom: "10px" }}
                                label='Full Name'
                                name='fullName'>
                                <Input
                                    disabled
                                    placeholder='Full name'
                                />
                            </Form.Item>

                            <Form.Item
                                style={{ marginBottom: "10px" }}
                                label='Join Date'
                                name='joinDate'
                                rules={[
                                    {
                                        required: true,
                                        message: "Please select join date!",
                                    },
                                ]}>
                                <DatePicker
                                    format="DD-MM-YYYY"
                                    style={{ width: "100%" }}
                                    disabled={!selectedUser}
                                />
                            </Form.Item>

                            <Form.Item
                                style={{ marginBottom: "10px" }}
                                wrapperCol={{
                                    offset: 6,
                                    span: 12,
                                }}>
                                <Button
                                    onClick={() => setLoader(true)}
                                    type='primary'
                                    size='large'
                                    htmlType='submit'
                                    block
                                    loading={loader}
                                    disabled={!selectedUser}>
                                    Link User
                                </Button>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
            </UserPrivateComponent>
            <LinkCompanyTblData />
        </Fragment>
    );
};

export default LinkCompany;
// import {
//     Button,
//     Col,
//     DatePicker,
//     Form,
//     Input,
//     Row,
//     Typography,
//     Select
// } from "antd";
// import moment from "moment";
// import { Fragment, useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { toast } from "react-toastify";
// import {
//     loadAllAttendance,
// } from "../../redux/rtk/features/attendance/attendanceSlice";
// import { addLinkUser, loadAllIndivisualUser } from "../../redux/rtk/features/linkUser/linkUserSlice";
// import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
// import LinkCompanyTblData from "./linkCompanyTblData";

// const { Option } = Select;

// const LinkCompany = ({ drawer }) => {
//     const [loader, setLoader] = useState(false);
//     const [selectedUser, setSelectedUser] = useState(null);
//     const users = useSelector((state) => state.linkUser?.linkUser || []);
//     const dispatch = useDispatch();
//     const { Title } = Typography;
//     const [form] = Form.useForm();

//     useEffect(() => {
//         dispatch(loadAllIndivisualUser());
//     }, [dispatch]);

//     const onFinish = async (values) => {
//         if (values.joinDate) {
//             values.joinDate = moment(values.joinDate).format("YYYY-MM-DD");
//         }
//         setLoader(true);
//         const resp = await dispatch(addLinkUser({ 
//             id: selectedUser?.id, // Save user id as userId
//             joinDate: values.joinDate
//         }));
//         if (resp.payload?.message === "success") {
//             setLoader(false);
//             form.resetFields();
//             setSelectedUser(null);
//             dispatch(loadAllAttendance());
//         } else {
//             setLoader(false);
//         }
//     };

//     const onFinishFailed = () => {
//         toast.warning("Failed at updating user information");
//         setLoader(false);
//     };

//     const handleUserNameChange = (value) => {
//         const user = users.find(u => u.UserName === value);
//         setSelectedUser(user || null);
//         if (user) {
//             form.setFieldsValue({ fullName: `${user.firstName} ${user.lastName}` });
//         } else {
//             form.setFieldsValue({ fullName: null });
//         }
//     };

//     return (
//         <Fragment>
//             <UserPrivateComponent permission={"create-attendance"}>
//                 <Row className='mr-top' justify={drawer ? "center" : "space-between"}>
//                     <Col
//                         xs={24}
//                         sm={24}
//                         md={24}
//                         lg={drawer ? 22 : 12}
//                         xl={drawer ? 22 : 12}
//                         className='column-design border rounded card-custom'>
//                         <Title level={4} className='m-2 mt-5 mb-5 text-center'>
//                             User Information
//                         </Title>

//                         <Form
//                             form={form}
//                             style={{ marginBottom: "40px" }}
//                             name='basic'
//                             labelCol={{ span: 6 }}
//                             wrapperCol={{ span: 12 }}
//                             onFinish={onFinish}
//                             onFinishFailed={onFinishFailed}
//                             autoComplete='off'>
//                             <Form.Item
//                                 style={{ marginBottom: "10px" }}
//                                 label='User Name'
//                                 name='UserName'
//                                 rules={[
//                                     {
//                                         required: true,
//                                         message: "Please enter or select a user name!",
//                                     },
//                                 ]}>
//                                 <Select
//                                     showSearch
//                                     placeholder='Enter or Select User Name'
//                                     optionFilterProp="children"
//                                     onChange={handleUserNameChange}
//                                     filterOption={(input, option) =>
//                                         option.children.toLowerCase().includes(input.toLowerCase())
//                                     }>
//                                     {users.map(user => (
//                                         <Option key={user.id} value={user.UserName}>
//                                             {user.UserName}
//                                         </Option>
//                                     ))}
//                                 </Select>
//                             </Form.Item>

//                             <Form.Item
//                                 style={{ marginBottom: "10px" }}
//                                 label='Full Name'
//                                 name='fullName'>
//                                 <Input
//                                     disabled
//                                     placeholder='Full name will appear here'
//                                 />
//                             </Form.Item>

//                             <Form.Item
//                                 style={{ marginBottom: "10px" }}
//                                 label='Join Date'
//                                 name='joinDate'
//                                 rules={[
//                                     {
//                                         required: true,
//                                         message: "Please select join date!",
//                                     },
//                                 ]}>
//                                 <DatePicker
//                                     format="DD-MM-YYYY"
//                                     style={{ width: "100%" }}
//                                     disabled={!selectedUser}
//                                 />
//                             </Form.Item>

//                             <Form.Item
//                                 style={{ marginBottom: "10px" }}
//                                 wrapperCol={{
//                                     offset: 6,
//                                     span: 12,
//                                 }}>
//                                 <Button
//                                     onClick={() => setLoader(true)}
//                                     type='primary'
//                                     size='large'
//                                     htmlType='submit'
//                                     block
//                                     loading={loader}
//                                     disabled={!selectedUser}>
//                                     Update
//                                 </Button>
//                             </Form.Item>
//                         </Form>
//                     </Col>
//                 </Row>
//             </UserPrivateComponent>
//             <LinkCompanyTblData />
//         </Fragment>
//     );
// };

// export default LinkCompany;